import * as React from 'react'
import { FC } from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface ListItemProps {
  title: string
  subtitle?: React.ReactNode
}

const styles = {
  title: {
    fontFamily: 'Source Sans Pro Semibold',
  },
}

export const EntityInformationListItem: FC<ListItemProps> = (props) => {
  const { title, subtitle } = props

  return (
    <Box display="inline-block" mr={3}>
      <Typography sx={styles.title}>{title}:</Typography>
      <Typography>{subtitle}</Typography>
    </Box>
  )
}

EntityInformationListItem.displayName = 'EntityInformationListItem'
